import styled, { css } from 'styled-components';
import { theme } from '../themes';

export const baseButton = css`
  font-size: 1.2rem;
  font-weight: var(--font-weight-medium);
  color: white;
  background-color: var(--color-secondary-btn);
  padding: 12px 22px;
  border-radius: 4px;
  transition: var(--base-transition);
  border: 0;
  cursor: pointer;
  &:focus {
    outline: none;
    background-color: var(--color-secondary-btn);
  }
  &:hover {
    background-color: var(--color-secondary-btn);
  }
`
